import { type ProductBrief, type ProductSimple } from '@/domain/products/types';
import { SuccessToast } from '@/features/cart/components';
import { addToCart } from '@/features/cart/store/cart';
import { Button } from '@andritzot/metris-web-ui/inputs/button';
import { usePiwikPro } from '@piwikpro/next-piwik-pro';
import { type MouseEvent } from 'react';
import { toast } from 'react-toastify';

import styles from './ProductCard.module.scss';

interface AddToCartButtonProps {
  product: ProductSimple | ProductBrief;
  isInCart: boolean;
}

const AddToCartButton = ({ product, isInCart }: AddToCartButtonProps) => {
  const disabled = isInCart;
  const { eCommerce } = usePiwikPro();

  const handleAddToCart = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation(); // avoid opening modal
    eCommerce.ecommerceAddToCart([
      {
        sku: `${product.idProduct}`,
        name: product.product,
        category: ['group' in product ? product.group.productGroup : ''],
        price: 0,
        quantity: 1,
      },
    ]);
    addToCart({
      idProduct: product.idProduct,
      image2: product.image2,
      product: product.product,
      group: 'group' in product ? product.group.productGroup : '',
      documentation: product.documentation,
    });
    toast.success(<SuccessToast title={product.product} />, { autoClose: 5000 });
  };

  const renderButtonLabel = () => (disabled ? 'added' : 'add to cart');

  return (
    <div className={styles.buttonContainer}>
      <Button
        variant="outlined"
        disabled={disabled}
        onClick={handleAddToCart}
        sx={{
          backgroundColor: 'background.paper',
          border: '1px solid',
          borderColor: 'primary.main',
          color: 'primary.main',
          fontWeight: 'bold',
          fontSize: '14px',
          textTransform: 'uppercase',
          borderRadius: 0,
          margin: '1rem',
          padding: '10px 20px',
          '&:hover': { backgroundColor: 'primary.50' },
          '&:disabled': { borderColor: 'primary.200', color: 'primary.200' },
        }}
      >
        {renderButtonLabel()}
      </Button>
    </div>
  );
};

export default AddToCartButton;
